import { put, call } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import { fetchDataSummarySuccess, fetchDataSummaryRequest } from "./data-summary";
import { fetchDataSummary } from "../../api/api";

export function* handleFetchDataSummary(action: ReturnType<typeof fetchDataSummaryRequest>): SagaIterator {
  const params = action.payload;
  const data = yield call(fetchDataSummary, params);
  yield put(fetchDataSummarySuccess({ data, params }));
}
